export { SwiperComponent } from './swiper'
